<div class="row form-property  {{property?.styleClass ? property.styleClass : ''}}">
  <div
    class="col-lg-{{tooltip?10:12}}"
    [ngClass]="{'no-padding-right':tooltip}"
  >
    <span class="p-float-label">
      <input
        id="{{name}}"
        [ngModel]="value"
        class="p-filled"
        (ngModelChange)="change($event)"
        type="password"
        pPassword
        [readonly]="readonly"
        [ngClass]="{'disabled':readonly, 'property-invalid':notValid}"
        [showPassword]="showPassword"
        [feedback]="property.feedback"
        autocomplete="anyrandomstring"
        style="width: 100%"
        [autocomplete]="property.autocompleteOff?'new-password':''"
      />
      <label class="gs-float-label {{property?.labelClass ? property.labelClass : ''}}" [ngClass]="{'error-color':notValid}">{{label}}</label>    
      <span *ngIf="value && !showPassword"
            class="pointer show-hide-password-icon"
            [style.margin-left]="notValid ? '-62px' : '-35px'"
            [style]="{'position':'absolute', 'top':'8px', 'z-index':'10'}"
            (click)="show()">
        <i class="fas fa-eye"></i>
      </span>
      <span *ngIf="value && showPassword"
            class="pointer show-hide-password-icon"
            [style.margin-left]="notValid ? '-62px' : '-35px'"
            [style]="{'position':'absolute','top':'8px','z-in dex':'10'}"
            (click)="show()">
        <i class="fas fa-eye-slash"></i>
      </span>
      <span
        *ngIf="notValid"
        class="form-error"
        [style]="{'position':'absolute','margin-left':'-35px','top':'8px'}"
        pTooltip="{{property.validationMessage}}"
      >
        <i class="fas fa-info-circle fa-2x form-valid-icon error-color"></i>
      </span>
    </span>
  </div>
  <div *ngIf="tooltip" class="col-lg-2 property-tooltip">
    <span pTooltip="{{property.tooltip}}">
      <i class="fas fa-info-circle master-color"></i>
    </span>
  </div>
</div>
